import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { AuthProvider } from './context/AuthContext';
import ProtectedRoute from './components/auth/ProtectedRoute';
import AuthRedirect from './components/auth/AuthRedirect';
import Login from './components/auth/Login';
import Dashboard from './pages/dashboard/Dashboard';
import FormBuilder from './pages/form-builder/FormBuilder';
import PublicForm from './pages/public/PublicForm';
import FormResponses from './pages/responses/FormResponses';
import './App.css';
import FileDownload from './pages/file/FileDownload';

function App() {
  return (
    <AuthProvider>
      <Router>
        <div className="App">
          <Routes>
            <Route path="/login" element={<Login />} />
            <Route path="/form/:formId/fill" element={<PublicForm />} />
            <Route
              path="/dashboard"
              element={
                <ProtectedRoute>
                  <Dashboard />
                </ProtectedRoute>
              }
            />
            <Route
              path="/form/new"
              element={
                <ProtectedRoute>
                  <FormBuilder />
                </ProtectedRoute>
              }
            />
            <Route
              path="/form/:formId"
              element={
                <ProtectedRoute>
                  <FormBuilder />
                </ProtectedRoute>
              }
            />
            <Route
              path="/form/:formId/responses"
              element={
                <ProtectedRoute>
                  <FormResponses />
                </ProtectedRoute>
              }
            />
            <Route
              path="/download/:fileId"
              element={
                <ProtectedRoute>
                  <FileDownload />
                </ProtectedRoute>
              }
            />
            <Route path="/" element={<AuthRedirect />} />
          </Routes>
        </div>
      </Router>
    </AuthProvider>
  );
}

export default App;
